import React, { useEffect, useState } from 'react';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js/max';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import CountryFlag from './CountryFlag';
import './InternationalPhoneField.css';

const names = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['pt-BR'], { type: 'region' }) : null;
const countryName = (country) => names?.of(country) || country;
const countryLabel = (country) => `${countryName(country)} (+${getCountryCallingCode(country)})`;
const FONE_SIMPLES_0311 = true; // rollback: false (ou build.bak_EQUIPE_V2_0311_*)
const countries = getCountries().sort((a, b) => countryName(a).localeCompare(countryName(b), 'pt-BR'));

export default function InternationalPhoneField({ id, value, onChange, confirmation, disabled = false, optional = false }) {
  const [selectedCountry, setSelectedCountry] = useState('BR');
  useEffect(() => { if (confirmation.valid) setSelectedCountry(confirmation.country); }, [confirmation.valid, confirmation.country]);
  const country = confirmation.country || selectedCountry;
  const selectCountry = (nextCountry) => {
    setSelectedCountry(nextCountry);
    const code = getCountryCallingCode(nextCountry);
    // Keep the national part only when its previous country was validated.
    onChange(`+${code}${confirmation.valid ? confirmation.national : ''}`);
  };
  // FONE_SIMPLES_0311 (GROK2): um campo só, sem bandeira/DDI (+55 padrão silencioso), sem caixinha. Antigo abaixo (desligado).
  const digs0311 = String(value || '').replace(/\D/g, '');
  if (FONE_SIMPLES_0311) return <div className="international-phone-field">
    <Input id={id} type="tel" inputMode="tel" autoComplete="tel" value={value} disabled={disabled}
      onChange={(event) => onChange(event.target.value)} placeholder="DDD + número"
      aria-invalid={!!digs0311 && !confirmation.valid && !confirmation.unchanged} className="h-10" />
    {digs0311.length > 3 && !confirmation.valid && !confirmation.unchanged ? <p className="mt-1 text-[11px] text-red-500" data-cg-keep="1">Número incompleto.</p> : null}
  </div>;
  return <div className="international-phone-field">
    <div className="international-phone-inputs">
      <div className="international-phone-country">
        <label htmlFor={`${id}-country`} className="international-phone-label">País e DDI</label>
        <Select value={country} onValueChange={selectCountry} disabled={disabled}>
          <SelectTrigger id={`${id}-country`} aria-label="País do telefone" className="international-phone-select">
            <SelectValue><span className="international-phone-option"><CountryFlag country={country} /><span>{countryLabel(country)}</span></span></SelectValue>
          </SelectTrigger>
          <SelectContent className="international-country-options" collisionPadding={12}>
            {countries.map((item) => <SelectItem key={item} value={item} textValue={countryLabel(item)}>
              <span className="international-phone-option"><CountryFlag country={item} /><span>{countryLabel(item)}</span></span>
            </SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="international-phone-number">
        <label htmlFor={id} className="international-phone-label">Número completo</label>
        <Input id={id} type="tel" inputMode="tel" autoComplete="tel" value={value} disabled={disabled}
          onChange={(event) => onChange(event.target.value)} placeholder="+55 00 00000-0000"
          aria-describedby={`${id}-phone-help`} aria-invalid={!!value && !confirmation.valid && !confirmation.unchanged} />
      </div>
    </div>
    <p id={`${id}-phone-help`} className="international-phone-help">
      {confirmation.unchanged ? 'Número cadastrado preservado. Para alterá-lo, informe e confirme o telefone completo.'
        : confirmation.valid ? `${countryName(confirmation.country)} · ${confirmation.formatted}`
          : 'Informe país, DDD e número completo. No exterior, use + e o código do país.'}
    </p>
    {!confirmation.unchanged && !(optional && (!String(value || '').replace(/\D/g, '') || /^\+\d{1,3}$/.test(String(value || '').trim()))) && <label className={`international-phone-confirm${confirmation.valid ? '' : ' is-disabled'}`}>
      <input type="checkbox" checked={confirmation.confirmed} disabled={disabled || !confirmation.valid}
        onChange={(event) => confirmation.confirm(event.target.checked)} />
      <span>{confirmation.valid ? `Confirmo o telefone completo: ${confirmation.formatted}` : 'Confirmar país, DDD e número completo'}</span>
    </label>}
  </div>;
}
